import axios from "axios";
import { storeS } from "@/store.js";
import { eventB } from "@/main";
import { getTokenString } from "./tokenService";

const API_URL =
  (window.__ENV && window.__ENV.API_URL) ||
  process.env.API_URL || // если ещё и DefinePlugin используешь
  "https://api.inside.skyservice.online";

const instance = axios.create({
  baseURL: API_URL.replace(/\/+$/, ""),
  timeout: 10000,
});

instance.interceptors.request.use(
  (config) => {
    storeS.preloaderTable = true;
    if (config.method === "get" && config.params) {
      console.debug("[HTTP GET]", config.baseURL + (config.url || ""), config.params);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => {
    storeS.preloaderTable = false;

    // Семантика з документальної точки зору – неправильна (код 200, коли status: error)
    if (response.data?.status === "error") {
      const customError = new Error(response.data.error[0] || "Unknown error");
      customError.response = response.data.error[0];
      throw customError.response;
    }
    return response;
  },
  (error) => {
    storeS.preloaderTable = false;
    console.error("[HTTP ERROR]", error?.response?.status, error?.message);

    if (error.toJSON().config.method == "post") {
      let obj = {
        method: error.toJSON().config.method,
        api: error.toJSON().config.baseURL + error.toJSON().config.url,
        data: error.toJSON().config.data,
      };

      localStorage.setItem("toDoFirst", JSON.stringify(obj));
      // зберігаємо запит в LocalStorage

      storeS.preloaderTable = false;
      storeS.preloader = false;

      eventB.emit("errorWithReq", { status: true });
    }

    return Promise.reject(error);
  }
);

export default instance;
